<div class="modal-container">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">Code Review</h1>

    <!-- Progress message during generation -->
    <h3 *ngIf="isWaitingForCodeReview">Generating code review...</h3>

    <!-- Generate/Regenerate button (shown when not generating) -->
    <button mat-button
            class="datex-button secondary"
            *ngIf="!isWaitingForCodeReview"
            (click)="onGenerateClicked()">
      <div class="button-label">
        <div class="button-icon">
          <i class="icon icon-ic_fluent_sparkle_circle_20_regular"></i>
        </div>
        <div class="button-text">Generate</div>
      </div>
    </button>

    <!-- Stop button (shown when generating) -->
    <button mat-button
            class="datex-button secondary"
            *ngIf="isWaitingForCodeReview"
            (click)="onStopClicked()">
      <div class="button-label">
        <div class="button-icon">
          <i class="icon icon-ic_fluent_record_stop_20_regular"></i>
        </div>
        <div class="button-text">Stop</div>
      </div>
    </button>
  </div>

  <div mat-dialog-content
       class="modal-content"
       #contentArea
       (scroll)="onContentScroll($event)">
    <!-- Empty state (no review yet) -->
    <div *ngIf="!codeReviewMarkdown && !isWaitingForCodeReview"
         class="empty-state">
      <div class="empty-state-icon">
        <i class="icon icon-ic_fluent_document_search_20_regular"></i>
      </div>
      <p class="empty-state-message">No code review available yet.</p>
      <p class="empty-state-hint">Click "Generate" to create an AI-powered code review.</p>
    </div>

    <!-- Markdown viewer (when content exists) -->
    <app-markdown-viewer *ngIf="codeReviewMarkdown"
                         [content]="codeReviewMarkdown">
    </app-markdown-viewer>
  </div>

  <div mat-dialog-actions
       class="modal-toolbar commands">
    <button mat-button
            class="datex-button secondary"
            [disabled]="!canScrollToTop"
            (click)="scrollToTop()">
      Back to top
    </button>
    <button mat-button
            class="datex-button secondary"
            (click)="onClose()">
      Close
    </button>
  </div>
</div>